export default "__VITE_ASSET__BeDe5WwQ__"